module.exports = __webpack_public_path__ + "img/vehicle-info-2.d44a7f03.png";